import React, { Component } from 'react';
import { Form, Modal, Select, DatePicker, InputNumber, message } from 'antd';
import moment from 'moment';
import { services } from '@comall-backend-builder/core';
import { errorHandle } from '../../services';
import './index.less';

const { Option } = Select;
const api = services.api;
/**
 * 商品资料预览商品
 */
class Pulloffputonsaleontime extends Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: false,
            inputVisible: props.rows.putOnSaleStatus == '1' ? true : false,
            showPutOnVisible: props.rows.saleStatus == 'NOT_SALES' ? true : false,
            pullOffVisible: this.props.rows.pullOffSaleStatus == '1' ? true : false,
        };
    }

    showModal = () => {
        console.log('props是什么东西？',this.props);
        this.setState({
            visible: true,
            inputVisible: this.props.rows.putOnSaleStatus == '1' ? true : false,
            showPutOnVisible: this.props.rows.saleStatus == 'NOT_SALES' ? true : false,
            pullOffVisible: this.props.rows.pullOffSaleStatus == '1' ? true : false,
        });
        this.props.form.setFields({
            putOnSaleStatus: {
                value: this.props.rows.putOnSaleStatus,
            },
            putOnSaleTime: {
                value:  moment(moment(this.props.rows.putOnSaleTime), 'YYYY-MM-DD HH:mm:ss')
            },
            pullOffSaleStatus: {
                value: this.props.rows.pullOffSaleStatus,
            },
            pullOffSaleTime: {
                value:  moment(moment(this.props.rows.pullOffSaleTime), 'YYYY-MM-DD HH:mm:ss')
            },
        });
    };

    handleOk = (e) => {
        console.log(this.props.entity);
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                let value;
                if (this.props.rows.saleStatus == 'NOT_SALES') {
                    if (this.state.inputVisible) {
                        let putOnSaleTime = values.putOnSaleTime.format('YYYY-MM-DD HH:mm:ss');
                        value = {
                            put_on_sale_status: values.putOnSaleStatus,
                            put_on_sale_time: putOnSaleTime,
                        };
                    } else {
                        value = {
                            put_on_sale_status: values.putOnSaleStatus,
                        };
                    }
                } else {
                    if (this.state.pullOffVisible) {
                        let pullOffSaleTime = values.pullOffSaleTime.format('YYYY-MM-DD HH:mm:ss');
                        value = {
                            pull_off_sale_status: values.pullOffSaleStatus,
                            pull_off_sale_time: pullOffSaleTime,
                        };
                    } else {
                        value = {
                            pull_off_sale_status: values.pullOffSaleStatus,
                        };
                    }
                }

                console.log(value)
                api.put(value, { apiPath: `/products/${this.props.rows.id}` })
                    .then(() => {
                        message.success('修改成功');
                    })
                    .catch(errorHandle);
                this.setState({
                    visible: false,
                });
                let params = {
                    type: 'FK_POINTS'
                }
                // 列表数据刷新
                this.props.entity.search({
                    ...params,
                    ...this.props.entity.filters,
                });
            } else {
                message.error('请填写完整表单再提交');
            }
        });
    };

    handleCancel = (e) => {
        this.props.form.resetFields();
        this.setState({
            visible: false,
        });
    };

    handleSelectChange = (value) => {
        if (value == '1') {
            this.setState(
                {
                    inputVisible: true,
                },
                () => {
                    // this.props.form.setFields({
                    //     pre_send_day: {
                    //         value: 10,
                    //     },
                    // });
                }
            );
        } else {
            this.setState({
                inputVisible: false,
            });
        }
    };
    handlePullOffSelectChange = (value) => {
        if (value == '1') {
            this.setState(
                {
                    pullOffVisible: true,
                },
                () => {
                    // this.props.form.setFields({
                    //     pre_send_day: {
                    //         value: 10,
                    //     },
                    // });
                }
            );
        } else {
            this.setState({
                pullOffVisible: false,
            });
        }
    };
    render() {
        const { visible, inputVisible, showPutOnVisible, pullOffVisible } = this.state;
        return (
            <div>
                <a target="_blank" onClick={this.showModal}>
                    定时上下架设置
                </a>
                <Modal visible={visible} onOk={this.handleOk} onCancel={this.handleCancel}>
                    <Form layout="vertical">
                        {showPutOnVisible && (
                            <Form.Item label="是否定时上架">
                                {this.props.form.getFieldDecorator('putOnSaleStatus', {
                                    rules: [{ required: true, message: '请选择是否定时上架' }],
                                })(
                                    <Select
                                        placeholder="请选择是否定时上架"
                                        onChange={this.handleSelectChange}
                                    >
                                        <Option value="1">是</Option>
                                        <Option value="0">否</Option>
                                    </Select>
                                )}
                            </Form.Item>
                        )
                        }
                        {showPutOnVisible && inputVisible && (
                            <>
                                <Form.Item label="定时上架时间">
                                    {this.props.form.getFieldDecorator('putOnSaleTime', {
                                        rules: [
                                            {
                                                type: 'object',
                                                required: true,
                                                message: '请选择定时上架时间',
                                            },
                                        ],
                                    })(<DatePicker  showTime format="YYYY-MM-DD HH:mm:ss" />)}
                                </Form.Item>
                            </>
                        )}
                        {!showPutOnVisible && (
                            <Form.Item label="是否定时下架">
                                {this.props.form.getFieldDecorator('pullOffSaleStatus', {
                                    rules: [{ required: true, message: '请选择是否定时下架' }],
                                })(
                                    <Select
                                        placeholder="请选择是否定时下架"
                                        onChange={this.handlePullOffSelectChange}
                                    >
                                        <Option value="1">是</Option>
                                        <Option value="0">否</Option>
                                    </Select>
                                )}
                            </Form.Item>
                        )
                        }
                        {!showPutOnVisible && pullOffVisible && (
                            <>
                                <Form.Item label="定时下架时间">
                                    {this.props.form.getFieldDecorator('pullOffSaleTime', {
                                        rules: [
                                            {
                                                type: 'object',
                                                required: true,
                                                message: '请选择定时下架时间',
                                            },
                                        ],
                                    })(<DatePicker  showTime format="YYYY-MM-DD HH:mm:ss" />)}
                                </Form.Item>
                            </>
                        )}
                    </Form>
                </Modal>
            </div>
        );
    }
}

export default Form.create()(Pulloffputonsaleontime);
